import DuplicateStoredAnalysisCriteria from 'use-case/storedAnalysis/duplicate/duplicateStoredAnalysisCriteria';
import { getApiClient } from 'adapter/out/client/apiClient';
import StoredAnalysis from 'domain/entity/storedAnalysis';

const duplicateStoredAnalysisApiClient = getApiClient(
    (clientCriteria: DuplicateStoredAnalysisCriteria) => `dashboards/stored-analyses/${clientCriteria.id}/duplicate`,
    StoredAnalysis,
    (clientCriteria: DuplicateStoredAnalysisCriteria) => ({
        method: 'POST',
        body: JSON.stringify({ name: clientCriteria.name }),
        headers: { 'Content-Type': 'application/json' },
    })
);

export default duplicateStoredAnalysisApiClient;
